// Step 23 — contract body + approval fingerprint evidence.
//
// The `contract_detail_dict` from the REST endpoint carries the FULL
// body (no tool-side truncation). We still cap the visible preview at
// a reasonable length and expose a "visa fulltext" toggle — the AI
// tool `get_contract_draft` truncates at 8000 chars, so any longer
// text is already flagged as `body_truncated` when it arrives via
// that path.

import { useState } from "react";

import { AIEmpty, AISection } from "../AIPrimitives";

const _PREVIEW_CHARS = 1200;

export default function AIContractEvidence({ detail }) {
  const [showFull, setShowFull] = useState(false);
  if (!detail) return null;

  const body = detail.body || "";
  const truncated = body.length > _PREVIEW_CHARS;
  const visible = showFull || !truncated ? body : body.slice(0, _PREVIEW_CHARS);

  return (
    <AISection
      title="Avtalstext & underlag"
      right={
        detail.approved_body_hash ? (
          <span className="qai-page-section-hint">
            Godkänd hash · {detail.approved_body_hash.slice(0, 12)}…
          </span>
        ) : null
      }
    >
      <div className="qai-contract-evidence">
        {body ? (
          <>
            <pre className="qai-contract-body">{visible}</pre>
            {truncated && (
              <button
                type="button"
                className="qai-page-section-link"
                onClick={() => setShowFull((s) => !s)}
              >
                {showFull ? "Dölj fulltext" : "Visa hela avtalstexten"}
              </button>
            )}
          </>
        ) : (
          <AIEmpty title="Ingen avtalstext registrerad." />
        )}

        {detail.approved_body_hash && (
          <div className="qai-contract-evidence-hash">
            <div className="qai-contract-evidence-hash-title">
              Godkänd sha256(body)
            </div>
            <code className="qai-contract-evidence-hash-value">
              {detail.approved_body_hash}
            </code>
            <div className="qai-contract-evidence-hash-note">
              Fingerprint sattes när en människa klickade Godkänn i
              granskningsvyn. Alla efterföljande bytes (t.ex. till
              DocuSeal) verifieras mot detta värde.
            </div>
          </div>
        )}

        {!detail.approved_body_hash && (
          <div className="qai-contract-evidence-nohash">
            Ingen godkänd fingerprint finns registrerad — utkastet är
            inte godkänt av en människa än.
          </div>
        )}
      </div>
    </AISection>
  );
}
